import { render } from "./login_form.vue?vue&type=template&id=508f3ec3"
import script from "./login_form.js?vue&type=script&lang=js"
export * from "./login_form.js?vue&type=script&lang=js"

import "./login_form.vue?vue&type=style&index=0&id=508f3ec3&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__